import React, {Component} from 'react';
import { Select, SelectItem } from 'carbon-components-react';
import PropertyComponent from './PropertyComponent';
import * as midi from '../js/rpl_midi.js';

class NoteDivisionParameterSelect extends PropertyComponent {

	constructor(props) {
		super(props);

		this.range        = props.range;

		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		let items = [];
		items.push(<SelectItem value="0" text="Off"/>)
		if (this.range != "fast") {
		  items.push(<SelectItem value="1" text="8m"/>)
		  items.push(<SelectItem value="2" text="7m"/>)
		  items.push(<SelectItem value="3" text="6m"/>)
		  items.push(<SelectItem value="4" text="5m"/>)
		  items.push(<SelectItem value="5" text="4m"/>)
		  items.push(<SelectItem value="6" text="3m"/>)
		  items.push(<SelectItem value="7" text="2m"/>)
		  items.push(<SelectItem value="8" text="2m triplet"/>)
		  items.push(<SelectItem value="9" text="Dotted whole note"/>)
		}
		items.push(<SelectItem value="10" text="Whole note"/>)
		items.push(<SelectItem value="11" text="Whole note triplet"/>)
		items.push(<SelectItem value="12" text="Dotted 1/2 note"/>)
		items.push(<SelectItem value="13" text="1/2 note"/>)
		items.push(<SelectItem value="14" text="1/2 note triplet"/>)
		items.push(<SelectItem value="15" text="Dotted 1/4 note"/>)
		items.push(<SelectItem value="16" text="1/4 note"/>)
		items.push(<SelectItem value="17" text="1/4 note triplet"/>)
		items.push(<SelectItem value="18" text="Dotted 1/8th note"/>)
		items.push(<SelectItem value="19" text="1/8th note"/>)
		items.push(<SelectItem value="20" text="1/8th note triplet"/>)
		items.push(<SelectItem value="21" text="Dotted 1/16th note"/>)
		items.push(<SelectItem value="22" text="1/16th note"/>)
		items.push(<SelectItem value="23" text="1/16th note triplet"/>)
		items.push(<SelectItem value="24" text="Dotted 1/32nd note"/>)
		items.push(<SelectItem value="25" text="1/32nd note"/>)
		items.push(<SelectItem value="26" text="1/32nd note triplet"/>)
		if (this.range != "slow") {
		  items.push(<SelectItem value="27" text="Dotted 1/64th note"/>)
		  items.push(<SelectItem value="28" text="1/64th note"/>)
		  items.push(<SelectItem value="29" text="1/64th note triplet"/>)
		  items.push(<SelectItem value="30" text="Dotted 1/128th note"/>)
		  items.push(<SelectItem value="31" text="1/128th note"/>)
		}

		return (
	  				<Select value={this.state.value} labelText={this.labelText} onChange={this.handleChange} disabled={this.state.disabled}>
						{items}
	  				</Select>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setIndexedParameterValue(this.propId, newValue);
	}

	handleControlChange(ccNum, ccValue) {
		this.setState({value: ccValue});
	}

	setValue(x) {
		this.setState({value: x});
	}
}

export default NoteDivisionParameterSelect;

